import {
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
  ProjectState_Warranty_getInstance3k7ift69kuu7o as ProjectState_Warranty_getInstance,
  ProjectState_Terminated_getInstancedn60ew509y4p as ProjectState_Terminated_getInstance,
  ProjectState_Cancelled_getInstanceoirlccakusgk as ProjectState_Cancelled_getInstance,
  ProjectState_Abandoned_getInstance19b47j86nick as ProjectState_Abandoned_getInstance,
  IncidentState_RequestingReview_getInstance9azcsnvsfz39 as IncidentState_RequestingReview_getInstance,
  LineItemState_InReview_getInstancet938lsxp894e as LineItemState_InReview_getInstance,
  LineItemState_Cancelled_getInstance3kcyrqker8w6h as LineItemState_Cancelled_getInstance,
  ProjectState_PendingStart_getInstance2dqkzmcm0blyg as ProjectState_PendingStart_getInstance,
  ProjectState_Locked_getInstance2lzy284wfpx83 as ProjectState_Locked_getInstance,
  Companion_getInstance1toq7c46z6qs1 as Companion_getInstance,
  LineItemState_NotStarted_getInstance3brd4lyoananz as LineItemState_NotStarted_getInstance,
  LineItemState_InProgress_getInstance30c0b4tuqukui as LineItemState_InProgress_getInstance,
  ProjectState_Creating_getInstancegu71uom71mst as ProjectState_Creating_getInstance,
  ProjectState_Invited_getInstancendchtgzjx7u0 as ProjectState_Invited_getInstance,
  ProjectState_WaitingApproval_getInstance1ditr18fxhnoh as ProjectState_WaitingApproval_getInstance,
  LineItemState_Complete_getInstancefayisedsonfg as LineItemState_Complete_getInstance,
  LineItemState_ForceComplete_getInstance30t7ooav0u0dj as LineItemState_ForceComplete_getInstance,
  LineItemState_Resolved_getInstance3gyqdeh0a3lwt as LineItemState_Resolved_getInstance,
  LineItemState_Settled_getInstance301yvu41ltgpc as LineItemState_Settled_getInstance,
  LineItemState_Handled_getInstance2darlslw9y3nm as LineItemState_Handled_getInstance,
  LineItemState_AutoAccepted_getInstancej9rcu6sgbxxq as LineItemState_AutoAccepted_getInstance,
  LineItemState_Disputed_getInstance1ejlicwa0ud20 as LineItemState_Disputed_getInstance,
  ProjectState_Accepted_getInstance2l1kftynf92aa as ProjectState_Accepted_getInstance,
  ProjectState_AwaitingFunding_getInstance2uhrgbgvubwqq as ProjectState_AwaitingFunding_getInstance,
  get_entries3onyqwuzh1iwq as get_entries,
  ProjectState_Disputed_getInstance3jjamycmvlpib as ProjectState_Disputed_getInstance,
  ProjectState_TransferringFunds_getInstance1fufy8va5bpur as ProjectState_TransferringFunds_getInstance,
  LineItemState_OnHold_getInstance5v65qotr6ndv as LineItemState_OnHold_getInstance,
} from './enums.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function displayState(_this__u8e3s4) {
  return displayState_1(_this__u8e3s4.r6k_1);
}
function get_inactiveStates(_this__u8e3s4) {
  return setOf([ProjectState_Complete_getInstance(), ProjectState_Warranty_getInstance(), ProjectState_Terminated_getInstance(), ProjectState_Cancelled_getInstance(), ProjectState_Abandoned_getInstance()]);
}
function displayState_0(_this__u8e3s4) {
  switch (_this__u8e3s4.b4_1) {
    case 1:
    case 2:
    case 3:
    case 5:
      return IncidentState_RequestingReview_getInstance();
    default:
      return _this__u8e3s4;
  }
}
function displayState_1(_this__u8e3s4) {
  switch (_this__u8e3s4.b4_1) {
    case 4:
    case 5:
    case 6:
    case 7:
      return LineItemState_InReview_getInstance();
    default:
      return _this__u8e3s4;
  }
}
function isFinal(_this__u8e3s4) {
  return isComplete(_this__u8e3s4) || _this__u8e3s4.equals(LineItemState_Cancelled_getInstance());
}
function canFileIncidents(_this__u8e3s4) {
  return _this__u8e3s4.d4(ProjectState_PendingStart_getInstance()) >= 0 && _this__u8e3s4.d4(ProjectState_Locked_getInstance()) < 0;
}
function isContractorEditable(_this__u8e3s4) {
  return !get_nonContractorEditableStates(Companion_getInstance()).t1(_this__u8e3s4);
}
function newChangesAllowed(_this__u8e3s4) {
  return _this__u8e3s4.equals(LineItemState_NotStarted_getInstance()) || _this__u8e3s4.equals(LineItemState_InProgress_getInstance());
}
function newChangesAllowed_0(_this__u8e3s4) {
  return isContractorEditable(_this__u8e3s4) && !isProjectLocked(_this__u8e3s4) && _this__u8e3s4.d4(ProjectState_Creating_getInstance()) > 0;
}
function isProjectLocked(_this__u8e3s4) {
  return setOf([ProjectState_Invited_getInstance(), ProjectState_WaitingApproval_getInstance()]).t1(_this__u8e3s4);
}
function isPendingCompletion(_this__u8e3s4) {
  switch (_this__u8e3s4.b4_1) {
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
    case 9:
    case 11:
      return true;
    default:
      return false;
  }
}
function isComplete(_this__u8e3s4) {
  return setOf([LineItemState_Complete_getInstance(), LineItemState_ForceComplete_getInstance(), LineItemState_Resolved_getInstance(), LineItemState_Settled_getInstance(), LineItemState_Handled_getInstance(), LineItemState_AutoAccepted_getInstance()]).t1(_this__u8e3s4);
}
function newTasksAllowed(_this__u8e3s4) {
  return !nonEditable(_this__u8e3s4);
}
function newTasksAllowed_0(_this__u8e3s4) {
  return isContractorEditable(_this__u8e3s4) && !isProjectLocked(_this__u8e3s4);
}
function newRequiredTasksAllowed(_this__u8e3s4) {
  return newTasksAllowed(_this__u8e3s4) && !isPendingCompletion(_this__u8e3s4);
}
function newNotesAllowed(_this__u8e3s4) {
  return !nonEditable(_this__u8e3s4) && !_this__u8e3s4.equals(LineItemState_Disputed_getInstance());
}
function newNotesAllowed_0(_this__u8e3s4) {
  return isContractorEditable(_this__u8e3s4) && !isProjectLocked(_this__u8e3s4);
}
function isCancellable(_this__u8e3s4) {
  return setOf([ProjectState_Invited_getInstance(), ProjectState_WaitingApproval_getInstance(), ProjectState_Accepted_getInstance(), ProjectState_AwaitingFunding_getInstance()]).t1(_this__u8e3s4);
}
function get_employeeVisibleStates(_this__u8e3s4) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_entries();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.d4(ProjectState_Invited_getInstance()) >= 0) {
      destination.v(element);
    }
  }
  return toSet(destination);
}
function get_nonContractorEditableStates(_this__u8e3s4) {
  return setOf([ProjectState_Disputed_getInstance(), ProjectState_Locked_getInstance(), ProjectState_TransferringFunds_getInstance(), ProjectState_Complete_getInstance(), ProjectState_Warranty_getInstance(), ProjectState_Terminated_getInstance(), ProjectState_Cancelled_getInstance(), ProjectState_Abandoned_getInstance()]);
}
function nonEditable(_this__u8e3s4) {
  return isFinal(_this__u8e3s4) || _this__u8e3s4.equals(LineItemState_OnHold_getInstance());
}
//region block: exports
export {
  canFileIncidents as canFileIncidents2jxv4kkqx5ug0,
  displayState_0 as displayState2k8glkzyt1ny6,
  displayState as displayStatevz5dnqm1uehi,
  displayState_1 as displayState3v4rl6ol8mfdu,
  get_employeeVisibleStates as get_employeeVisibleStates1eu9d2kkcbve5,
  get_inactiveStates as get_inactiveStates2yk2ks5kh401v,
  isCancellable as isCancellable24xse61e0pt9z,
  isComplete as isComplete3isyniin1qz2u,
  isContractorEditable as isContractorEditable2xd7urpt5jbec,
  isFinal as isFinal1ds8cwv2a0e8r,
  isPendingCompletion as isPendingCompletion65tdr7y6lgp6,
  isProjectLocked as isProjectLocked21m24mmy2in1h,
  newChangesAllowed as newChangesAlloweduwl70y4cy8dt,
  newChangesAllowed_0 as newChangesAllowed2l43dpoyno2fl,
  newNotesAllowed_0 as newNotesAllowedq5ynuueymgu2,
  newNotesAllowed as newNotesAllowed1s45uieazjo3d,
  newRequiredTasksAllowed as newRequiredTasksAllowedvxh24ivnbst1,
  newTasksAllowed as newTasksAllowed26ihc5f4iqgon,
  newTasksAllowed_0 as newTasksAllowed2g7c6d9oaegnt,
};
//endregion

//# sourceMappingURL=statePermissions.mjs.map
